import { $host } from './index';

// Получить категории, к которым у админа есть доступ
export const getCategoriesForAdmin = async (userId) => {
  const { data } = await $host.get(`web/access/${userId}/chat-categories`);
  return data;
};

// Установить категории для админа
export const setChatCategories = async (userId, categoryIds) => {
  const { data } = await $host.put(`web/access/${userId}/chat-categories`, {
    categoryIds,
  });
  return data;
};
